// extracted by mini-css-extract-plugin
export default {"banner":"jC69k","adContainer":"zdwOU","player":"PFLha","content":"Xgt_s","icon":"kCGw7","info":"ublV7","text":"xLz8d","subtext":"Uhyl7","continueOverlay":"fCRaH","visible":"UwXTF"};